var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ima-transfer-modal"},_vm._l((_vm.options),function(option){return _c('button',{key:option,staticClass:"button is-info",attrs:{"type":"button"},on:{"click":function($event){_vm.onSelect(option)}}},[_c('span',{staticClass:"icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getPrettyLabel(option)))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03188e37","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/TransferModal.vue
// module id = 0gjN
// module chunks = 1